import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Co2ValueForm from '@/components/co2quiz/Co2ValueForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Co2BasketValue } from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { LabelsActions } from '@/stores/labels.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2Values',
  setup(__props) {

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const events = useEvents();

const questions = computed<Co2BasketValue[]>(() => store.state.co2.values);

const update = () => {
  store.dispatch(Co2QuizStoreActions.GetCo2Questions);
  store.dispatch(Co2QuizStoreActions.GetCo2Values);
};

onMounted(() => {
  store.dispatch(LabelsActions.GetLabels);

  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Category', key: 'categories', width: '30%' },
  { title: 'Value', key: 'value', width: '20%' },
  { title: 'State', key: 'translated', sortable: false, width: '5%' },
];

const editValue = (_: Event, { item }: { item: Co2BasketValue }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2ValueForm),
    data: item,
  });
};

const addValue = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2ValueForm),
  });
};

const filterTitle = ref<string>('');
const filteredValues = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.categories
          .map((c) => c.title)
          .join('')
          .toLowerCase()
          .indexOf(filterTitle.value) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("CO₂ Values ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, { onFilter: updateFilter }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: filteredValues.value,
        "onClick:row": editValue,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.translated": _withCtx(({ item }) => [
          _createVNode(TranslatedState, { item: item }, null, 8, ["item"])
        ]),
        "item.categories": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.categories[0]?.title), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addValue,
        color: "success",
        class: "mr-4"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Add Value")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})